import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, get, patch, post, put } from "helpers/api_helper"
import {
  ADD_ADMIN_USER,
  DELETE_ADMIN_USER,
  GET_ALL_USERS,
  GET_BRANCH_LIST,
  GET_ROLES_LIST,
  GET_USER_DETAILS,
  GET_USERS_LIST,
  UPDATE_ADMIN_USER,
  UPDATE_ADMIN_USER_STATUS,
  USER_AUTH_DETAILS,
} from "helpers/url_helper"

export const getAllUsers = createAsyncThunk(GET_ALL_USERS, async payload => {
  const response = await post(GET_ALL_USERS, payload)
  return response
})

export const updateAdminUserStatus = createAsyncThunk(
  UPDATE_ADMIN_USER_STATUS,
  async payload => {
    const response = await patch(UPDATE_ADMIN_USER_STATUS, payload)
    return response
  }
)

export const addAdminUser = createAsyncThunk(ADD_ADMIN_USER, async payload => {
  const response = await post(ADD_ADMIN_USER, payload)
  return response
})

export const updateAdminUser = createAsyncThunk(
  UPDATE_ADMIN_USER,
  async payload => {
    const response = await put(UPDATE_ADMIN_USER, payload)
    return response
  }
)

export const deleteAdminUser = createAsyncThunk(
  DELETE_ADMIN_USER,
  async payload => {
    const response = await del(DELETE_ADMIN_USER, payload)
    return response
  }
)

export const getAdminUserDetails = createAsyncThunk(
  GET_USER_DETAILS,
  async payload => {
    const response = await post(GET_USER_DETAILS, payload)
    return response
  }
)

export const getAllRoles = createAsyncThunk(GET_ROLES_LIST, async payload => {
  const response = await get(GET_ROLES_LIST)
  return response
})

export const getAllBranchs = createAsyncThunk(
  GET_BRANCH_LIST,
  async payload => {
    const response = await get(GET_BRANCH_LIST)
    return response
  }
)

export const getAuthDetails = createAsyncThunk(
  USER_AUTH_DETAILS,
  async payload => {
    const response = await get(USER_AUTH_DETAILS)
    return response
  }
)

export const getUsersList = createAsyncThunk(GET_USERS_LIST, async payload => {
  const response = await post(GET_USERS_LIST, payload)
  return response
})
